import React from "react";
import { Card, Text, Divider } from "@nextui-org/react";
import { motion } from "framer-motion";

const MotionCard = motion(Card);

const formatDate = (dateStr) => {
  if (!dateStr) return "N/A";
  const d = new Date(dateStr);
  return isNaN(d.getTime())
    ? dateStr
    : d.toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
};

const AltDeductionCard = ({ doc, checked, onToggle }) => {
  const shopCleared = doc?.clearedShopTotal ?? doc?.clearedShop ?? doc?.amount ?? 0;
  const sunilCCleared = doc?.clearedSunilC ?? doc?.clearedSunil ?? 0;
  const custCleared = doc?.clearedCustomerTotal ?? doc?.previousCustomerTotal ?? 0;
  const profitCleared = doc?.clearedProfit ?? doc?.previousProfit ?? (custCleared - sunilCCleared);

  return (
    <div className="linkWidth" onClick={() => onToggle?.(doc._id)}>
      <MotionCard
        variant="bordered"
        css={{
          mw: "550px",
          cursor: "pointer",
          borderColor: "$green300",
        }}
        whileTap={{ scale: 0.9, transition: { duration: 0.1 } }}
      >
        <Card.Header
          css={{
            display: "inline-flex",
            justifyContent: "space-between",
            alignItems: "center",
            py: "5px",
          }}
        >
          <Text b size="14px" color="$green800">
            Clear Entry
          </Text>
          <div style={{ display: "flex", gap: "6px", alignItems: "center" }}>
            <Text
              b
              size="12px"
              css={{
                br: "12px",
                bgColor: "$green50",
                px: "10px",
                py: "5px",
              }}
              color="$green800"
            >
              Deduction
            </Text>
            <input
              type="checkbox"
              checked={!!checked}
              onChange={() => onToggle?.(doc._id)}
              onClick={(e) => e.stopPropagation()}
              style={{
                width: "18px",
                height: "18px",
                cursor: "pointer",
                accentColor: "#10b981",
                marginLeft: "4px",
              }}
            />
          </div>
        </Card.Header>
        <Card.Divider />
        <Card.Body
          css={{
            display: "flex",
            flexDirection: "column",
            gap: "5px",
            py: "5px",
            alignItems: "center",
          }}
        >
          {/* 1. Shop Total */}
          <div className="groupCardFlex">
            <Text size="13px" b>
              Shop Total:
            </Text>
            <Text size="13px" b color="error">
              - &#8377; {Math.ceil(shopCleared).toLocaleString("en-IN")}
            </Text>
          </div>

          {/* 2. Sunil C */}
          <Divider />
          <div className="groupCardFlex">
            <Text size="13px" b>
              Sunil C:
            </Text>
            <Text size="13px" b color="warning">
              - &#8377; {Math.ceil(sunilCCleared).toLocaleString("en-IN")}
            </Text>
          </div>

          {/* 3. Customer */}
          <Divider />
          <div className="groupCardFlex">
            <Text size="13px" b>
              Customer:
            </Text>
            <Text size="13px" b color="default">
              - &#8377; {Math.ceil(custCleared).toLocaleString("en-IN")}
            </Text>
          </div>

          {/* 4. Profit */}
          <Divider />
          <div className="groupCardFlex">
            <Text size="13px" b>
              Profit:
            </Text>
            <Text size="13px" b color={profitCleared >= 0 ? "secondary" : "error"}>
              {profitCleared < 0 ? "+" : "-"} &#8377;{" "}
              {Math.ceil(Math.abs(profitCleared)).toLocaleString("en-IN")}
            </Text>
          </div>

          {doc?.note && (
            <>
              <Divider />
              <div className="groupCardFlex">
                <Text size="13px" b>
                  Note:
                </Text>
                <Text
                  size="13px"
                  b
                  css={{
                    maxW: "65%",
                    textAlign: "right",
                    wordBreak: "break-word",
                  }}
                >
                  {doc.note}
                </Text>
              </div>
            </>
          )}

          <Divider />
          <div className="groupCardFlex">
            <Text size="12px" color="$gray700">
              Date:
            </Text>
            <Text size="12px" color="$gray700">
              {formatDate(doc?.createdAt || doc?.created)}
            </Text>
          </div>
        </Card.Body>
      </MotionCard>
    </div>
  );
};

export default AltDeductionCard;
